import { createUseStyles } from 'react-jss';

const styles = {
  tableHeading: {
    padding: '2.4rem 0rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  tableHeader: {
    boxSizing: 'border-box',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
